import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

const BlogIndex = () => (
  <Layout>
    <SEO title="catwomaniya" />
    <div className="container">
      <div className="hero fade-hero">
        <div className="hero-eyebrow">// building in public</div>
        <div className="hero-title">thinking out loud.</div>
        <div className="hero-sub">
          5+ years in B2B growth. Creative side quests and writing about AI —
          what's actually useful, what's not. Not big on gatekeeping, so some
          cool finds as well.
        </div>
      </div>

      <div className="sections fade-sections">
        <Link className="section-row" to="/unfiltered">
          <div className="section-left">
            <div className="section-num">01</div>
            <div className="section-title">Unfiltered</div>
          </div>
          <div className="section-arrow">→</div>
        </Link>
        <Link className="section-row" to="/experiments">
          <div className="section-left">
            <div className="section-num">02</div>
            <div className="section-title">Mini Experiments</div>
          </div>
          <div className="section-arrow">→</div>
        </Link>
        <Link className="section-row" to="/finds">
          <div className="section-left">
            <div className="section-num">03</div>
            <div className="section-title">Good Finds</div>
          </div>
          <div className="section-arrow">→</div>
        </Link>
      </div>
    </div>
  </Layout>
)

export default BlogIndex

export const pageQuery = graphql`
  query HomePageData {
    site {
      siteMetadata {
        title
      }
    }
  }
`
